import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { HiddenFormInput } from './input-form.component';

export default [
    registerFormInputComponent('hidden-form-input', HiddenFormInput),
];
